import React from 'react'
import { Alert, Card, Col, Form, Input, Radio, Row } from 'antd'
import { useDeepEffect } from '../../utils/hooks'
import { ButtonEx } from '../../styles/button.style'
import { useDispatch } from 'react-redux'
import { saveBrandSetting } from '../../modules/brand'
import { isEmpty, isUndefined } from 'lodash'

const BrandSetting = ({ brand , form }) => {
  const dispatch = useDispatch()
  const { validateFields, getFieldDecorator, setFieldsValue } = form

  useDeepEffect(() => {
    if (!isEmpty(brand) && !isUndefined(brand)) {
      setFieldsValue({
        factorMaterialScore: brand.factorMaterialScore,
        factorNotSupportScore: brand.factorNotSupportScore,
        factorProductScore: brand.factorProductScore,
        factorSupportScore: brand.factorSupportScore,
        status: brand.status
      })
    }
  }, [brand])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          brandId: brand.id,
          factorProductScore: Number(values.factorProductScore),
          factorMaterialScore: Number(values.factorMaterialScore),
          factorSupportScore: Number(values.factorSupportScore),
          factorNotSupportScore: Number(values.factorNotSupportScore),
          status: values.status
        }

        await dispatch(saveBrandSetting(data))
      }
    })
  }

  return (
    <Card title="Brand Setting">
    <Form onSubmit={onSubmit}>
      <Row type="flex" gutter={[8, 8]}>
        <Col span={24}>
          <Card title="การคำนวณคะแนนสินค้า">
            <Row type="flex" gutter={[8, 8]}>
              <Col span={10}>
                <span>Factor คะแนนสินค้าของแบรนด์</span>
              </Col>
              <Col span={6}>
                <Form.Item>
                  {getFieldDecorator(`factorProductScore`, {
                    rules: [{ required: true, message: 'กรุณากรอก' }]
                  })(<Input />)}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" gutter={[8, 8]}>
              <Col span={10}>
                <span>Factor คะแนนสินค้าอื่น</span>
              </Col>
              <Col span={6}>
                <Form.Item>
                  {getFieldDecorator(`factorMaterialScore`, {
                    rules: [{ required: true, message: 'กรุณากรอก' }]
                  })(<Input />)}
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24}>
          <Card title="การนับคะแนน (วัสดุที่ไม่ได้เลือกไว้)">
            <Row type="flex" gutter={[8, 8]}>
              <Col span={10}>
                <span>Factor คะแนนของวัสดุที่สนับสนุน</span>
              </Col>
              <Col span={6}>
                <Form.Item>
                  {getFieldDecorator(`factorSupportScore`, {
                    rules: [{ required: true, message: 'กรุณากรอก' }]
                  })(<Input />)}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" gutter={[8, 8]}>
              <Col span={10}>
                <span>Factor คะแนนของวัสดุที่ไม่ได้สนับสนุน</span>
              </Col>
              <Col span={6}>
                <Form.Item>
                  {getFieldDecorator(`factorNotSupportScore`, {
                    rules: [{ required: true, message: 'กรุณากรอก' }]
                  })(<Input />)}
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={24}>
          <Card title="บัญชี">
            <Row type="flex" gutter={[8, 8]}>
              <Col span={8}>
                <span>ปิดการใช้งาน Brand</span>
              </Col>
              <Col span={16}>
                <Form.Item>
                  {getFieldDecorator(`status`)(
                    <Radio.Group>
                      <Radio value={true}>เปิดใช้งาน</Radio>
                      <Radio value={false}>ปิดใช้งาน</Radio>
                    </Radio.Group>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Alert
                  message="คำเตือน ระบบจะไม่แสดง Brand รวมถึง Barcode Official ที่ผูกกับ Brand ในแอพพลิเคชัน Green2Get"
                  type="warning"
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Row type="flex" justify="end" style={{ marginTop: '10px' }}>
        <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
          บันทึก
        </ButtonEx>
      </Row>
    </Form>
    </Card>
  )
}

const WrappedBrandSetting = Form.create({ name: 'BrandSetting' })(BrandSetting)
export default WrappedBrandSetting



// WEBPACK FOOTER //
// ./src/pages/BrandSetting/index.js